<template>
  <div class="header">
    <span class="floatLeft logo">Slow Band</span>
    <span class="floatRight">
      <div v-if="!isSignedIn">
        <button class="buttonStd" @click.prevent="signin">Sign In</button>
        &nbsp;
        <button class="buttonStd" @click.prevent="signup">Sign Up</button>
      </div>
      <div v-else>
        <button class="buttonStd" @click.prevent="logout">logout</button>
      </div>
    </span>
    <div v-if="showModalComp === true">
      <SignUpModal />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import gql from "graphql-tag";
import SignUpModal from "../components/modal/SignUp.vue";
import { onLogin } from "../vue-apollo.js";

export default {
  name: "Header",
  components: {
    SignUpModal: SignUpModal
  },
  data() {
    return {
      activeUser: null,
      showModal: false,
      appUser: {
        id: "",
        email: ""
      }
    };
  },
  created() {
    this.showModal = this.getSignUpModal;
  },
  methods: {
    ...mapActions([
      "signIn",
      "signOut",
      "showSignUpModal",
      "checkSignIn",
      "setSignInState",
      "setUserSignedUp",
      "setLogin",
      "setUnsignedUser"
    ]),
    signin() {
      let self = this;
      this.signIn().then(async attempt => {
        if (attempt) {
          let token = self.getToken;
          localStorage.setItem("apollo-token", token);
          let id = self.getUser.user.uid;
          onLogin(this.$apolloProvider.defaultClient, token).then(async () => {
            let user_exists = await this.$apollo.query({
              query: gql`
                query($user_id: String!) {
                  users(where: { user_id: { _eq: $user_id } }) {
                    user_id
                    user_email
                    username
                  }
                }
              `,
              variables: {
                user_id: id
              }
            });
            if (user_exists.data.users.length > 0) {
              let user = {
                uid: user_exists.data.users[0].user_id,
                user_email: user_exists.data.users[0].user_email
              };
              self.setUserSignedUp(true);
              self.setSignInState(true);
              self.$router.push("Recent");
              self.updateSignIn(user);
            } else {
              self.setUserSignedUp(false);
              self.showSignUpModal(true);
              self.getUser;
            }
          });
        }
      });
    },
    async logout() {
      let logoutuser = this.getUser.user.uid;
      let token = this.getToken;
      this.signOut().then(() => {
        let session_end = new Date().toISOString();
        // onLogout(this.$apolloProvider.defaultClient, token).then(async() => {
        this.$apollo.mutate(
          {
            mutation: gql`
              mutation insertLogin(
                $user_id: String!
                $user_email: String
                $login_time: timestamptz
                $login_status: String
              ) {
                insert_user_logins_one(
                  object: {
                    user_id: $user_id
                    user_email: $user_email
                    login_time: $login_time
                    login_status: $login_status
                  }
                ) {
                  login_id
                  login_time
                  user_email
                  login_status
                }
              }
            `,
            variables: {
              user_id: logoutuser,
              login_time: session_end,
              user_email: "jbeetz@hotmail.com",
              login_status: "out"
            }
          },
          token
        );
        this.$router.push("/");
      });
      // });
    },
    signup() {
      this.showSignUpModal(true);
    },
    updateSignIn(user) {
      let token = localStorage.getItem("apollo-token");
      let session_start = new Date();
      this.$apollo.mutate(
        {
          mutation: gql`
            mutation insertLogin(
              $user_id: String!
              $user_email: String
              $login_time: timestamptz
              $login_status: String
            ) {
              insert_user_logins_one(
                object: {
                  user_id: $user_id
                  user_email: $user_email
                  login_time: $login_time
                  login_status: $login_status
                }
              ) {
                login_id
                login_time
                user_email
                login_status
              }
            }
          `,
          variables: {
            user_id: user.uid,
            login_time: session_start.toISOString(),
            user_email: user.user_email,
            login_status: "in"
          }
        },
        token
      );
    }
  },
  computed: {
    ...mapGetters(["getUser", "getSignedIn", "getSignUpModal", "getToken"]),
    isSignedIn() {
      return this.getSignedIn;
    },
    showModalComp() {
      return this.getSignUpModal;
    },
    currentRoute() {
      if (this.$router.currentRoute.name === "Privacy") {
        return false;
      } else {
        return true;
      }
    }
  },
  apollo: {}
};
</script>
<style lang="sass"></style>
